import LearningAgent from './LearningAgent';
import LineamientosAgent from './LineamientosAgent';
import LRequerimientosAgent from './lrequerimientos';
import InventoryAgent from './InventoryAgent';
import { n8nService } from '../api/n8nService';
import { BsJournalText, BsDatabaseCheck, BsDatabaseAdd, BsJournalArrowUp } from 'react-icons/bs';
// Importar otros agentes aquí cuando se creen

/**
 * Configuración de los agentes disponibles
 */
const subdomain = window.location.hostname.split('.')[0];
const useSameOriginWebhookProxy = subdomain === 'vsise';
const externalN8nBaseUrl = 'https://n8ndev.ia.sistran.com.co';

function buildWebhookEndpoint(path) {
  if (useSameOriginWebhookProxy) {
    return path;
  }

  return `${externalN8nBaseUrl}${path}`;
}

const AGENT_CONFIGS = {
  LRequerimientos: {
    key: 'LRequerimientos',
    name: 'Agente de levantamiento de Requerimientos',
    description: 'Soy experto en el levantamiento de requerimientos.',
    icon: BsJournalArrowUp,
    webhookEndpoint: buildWebhookEndpoint('/webhook/asistente_req_multiagente'),
    agentClass: LRequerimientosAgent,
  },
  learning: {
    key: 'learning',
    name: 'Agente de Especificaciones Funcionales',
    description: 'Soy experto en documentación BE y puedo generar EF.',
    icon: BsJournalText,
    webhookEndpoint: buildWebhookEndpoint('/webhook/3db97ff9-f412-48fe-95ff-a507f8637022'),
    agentClass: LearningAgent,
  },
  Lineamientos: {
    key: 'Lineamientos',
    name: 'Agente de Lineamientos de Base de Datos',
    description: 'Soy experto en lineamientos de Bases de Datos de Sistran.',
    icon: BsDatabaseCheck,
    webhookEndpoint: buildWebhookEndpoint('/webhook/inputLDb'),
    agentClass: LineamientosAgent,
  },
  Inventory: {
    key: 'Inventory',
    name: 'Agente de Inventario de Activos',
    description: 'Soy experto en la consulta de Inventario de Activos.',
    icon: BsDatabaseAdd,
    webhookEndpoint: buildWebhookEndpoint('/webhook/inputInvAct'),
    agentClass: InventoryAgent,
  },
};

/**
 * Fábrica para crear instancias de agentes
 */
class AgentFactory {
  /**
   * Crea una instancia de un agente
   * @param {string} agentKey - Clave única del agente
   * @param {Object} customConfig - Configuración personalizada para el agente
   * @returns {AgentInterface} Instancia del agente
   */
  static createAgent(agentKey, customConfig = {}) {
    const agentConfig = AGENT_CONFIGS[agentKey];
    
    if (!agentConfig) {
      throw new Error(`No se encontró configuración para el agente: ${agentKey}`);
    }

    const config = { 
      ...agentConfig, 
      ...customConfig 
    };
    
    // Inyectar dependencias específicas del agente (learning, Lineamientos)
    if (['LRequerimientos', 'learning', 'Lineamientos', 'Inventory'].includes(agentKey)) {
      if (!n8nService) {
        throw new Error('n8nService no está configurado');
      }
      config.n8nService = n8nService;
    }
    
    const AgentClass = agentConfig.agentClass;
    
    if (!AgentClass) {
      throw new Error(`No se pudo crear el agente: ${agentKey} - Clase no definida`);
    }

    return new AgentClass(config);
  }

  /**
   * Obtiene la configuración de todos los agentes disponibles
   * @returns {Array<Object>} Lista de configuraciones de agentes
   */
  static getAvailableAgents() {
    return Object.values(AGENT_CONFIGS).map(({ agentClass, ...config }) => ({
      ...config,
    }));
  }

  /**
   * Obtiene la configuración de un agente específico
   * @param {string} agentKey - Clave única del agente
   * @returns {Object} Configuración del agente
   */
  static getAgentConfig(agentKey) {
    const config = AGENT_CONFIGS[agentKey];
    if (!config) {
      throw new Error(`No se encontró configuración para el agente: ${agentKey}`);
    }
    
    const { agentClass, ...agentConfig } = config;
    return agentConfig;
  }
}

export default AgentFactory;
